export default {
      id: "money-insurance-usage",
      viewBox: "0 0 33 32",
      url: __webpack_public_path__ + "sprite.svg#money-insurance",
      toString: function () {
        return this.url;
      }
    }